import type {GeneratedImagePartActionsProps} from '@Components/ai-chat-window/components/generated-image/generated-image.types';
import {PublishingOption} from '@Components/ai-chat-window/components/publishing-options/publishing-options.types';

export const MORE_OPTIONS_DROPDOWN_MODAL_PANEL_ID = 'assistant-message-more-options-dropdown-modal-panel-id';

export const AI_CHAT_PRIMARY_PUBLISHING_OPTION: PublishingOption = PublishingOption.PUBLISH_TO_SOCIAL_MEDIA;

/** The options events-calendar promotion chats surface as inline pills instead of menu entries. */
export const EVENTS_CALENDAR_PROMOTION_PUBLISHING_OPTIONS: PublishingOption[] = [PublishingOption.PUBLISH_TO_SOCIAL_MEDIA, PublishingOption.PUBLISH_AS_EMAIL_CAMPAIGN];

export interface AssistantMessageImagePartActionsRowProps extends GeneratedImagePartActionsProps {
  chatId: string;
  hashedId: string;
  isMobile?: boolean;
  isLastMessage: boolean;
  isMessageStreaming?: boolean;
  hasLayeredPoster: boolean;
}
